// extracted by mini-css-extract-plugin
export default {"customerContainer":"customers_customerContainer__PxkXc","customerContainer2":"customers_customerContainer2__SbteD","cardContainer":"customers_cardContainer__MrjXb"};